class ProductModalPopup extends HTMLElement {
  constructor() {
    super();
    this.triggers = document.querySelectorAll('.product-modal-trigger');
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    });

    // Handle ESC key and backdrop clicks for all modals
    document.addEventListener('click', this.handleBackdropClick.bind(this));
    document.addEventListener('keydown', this.handleEscKey.bind(this));
  }

  handleTriggerClick(event) {
    event.preventDefault();
    const trigger = event.currentTarget;
    const modalId = trigger.dataset.modalId;
    const modal = document.getElementById(modalId);
    
    if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
      this.trapFocus(modal);
    } else {
      // Fallback for browsers that don't support dialog
      this.showModalFallback(modal);
    }
  }

  handleBackdropClick(event) {
    const modal = event.target;
    if (modal.tagName === 'DIALOG' && modal.classList.contains('product-modal')) {
      const closeOnBackdrop = modal.dataset.closeOnBackdrop === 'true';
      
      // Check if click was on the backdrop (outside the dialog content)
      const rect = modal.getBoundingClientRect();
      const isClickInsideDialog = (
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width
      );
      
      if (!isClickInsideDialog && closeOnBackdrop && modal.open) {
        modal.close();
      }
    }
  }

  handleEscKey(event) {
    if (event.key === 'Escape') {
      const openModals = document.querySelectorAll('.product-modal[open]');
      openModals.forEach(modal => {
        const closeOnEsc = modal.dataset.closeOnEsc === 'true';
        if (closeOnEsc) {
          modal.close();
        }
      });
    }
  }

  trapFocus(modal) {
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;
    
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    
    // Focus the first focusable element
    firstFocusable.focus();
    
    // Trap focus within modal
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    });
  }

  // Fallback for browsers that don't support dialog element
  showModalFallback(modal) {
    if (!modal) return;
    
    modal.style.display = 'block';
    modal.setAttribute('open', '');
    
    // Create backdrop
    const backdrop = document.createElement('div');
    backdrop.classList.add('modal-backdrop-fallback');
    backdrop.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 999;
    `;
    
    document.body.appendChild(backdrop);
    modal.style.zIndex = '1000';
    
    // Handle close
    const closeModal = () => {
      modal.style.display = 'none';
      modal.removeAttribute('open');
      backdrop.remove();
    };
    
    // Close button
    const closeButton = modal.querySelector('.product-modal__close');
    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }
    
    // Backdrop click
    if (modal.dataset.closeOnBackdrop === 'true') {
      backdrop.addEventListener('click', closeModal);
    }
  }
}

// Initialize when DOM is ready
if (!customElements.get('product-modal-popup')) {
  customElements.define('product-modal-popup', ProductModalPopup);
}

// Initialize modals on page
document.addEventListener('DOMContentLoaded', () => {
  // Add close button functionality
  const closeButtons = document.querySelectorAll('.product-modal__close');
  closeButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const modal = e.target.closest('.product-modal');
      if (modal && typeof modal.close === 'function') {
        modal.close();
      } else {
        // Fallback
        modal.style.display = 'none';
        modal.removeAttribute('open');
        const backdrop = document.querySelector('.modal-backdrop-fallback');
        if (backdrop) backdrop.remove();
      }
    });
  });
  
  // Create custom element instance
  const modalElement = document.createElement('product-modal-popup');
  document.body.appendChild(modalElement);
});